import { Feature } from "geojson";
import { useMemo } from "react";
import { SelectionGeometry } from "src/js/stores/map/store";

import { RGBAColor } from "@deck.gl/core";
import { PathStyleExtension } from "@deck.gl/extensions";
import { GeoJsonLayer, GeoJsonLayerProps } from "@deck.gl/layers";

const WHITE: RGBAColor = [255, 255, 255, 255];

export function useUtilitiesBufferLayer(data?: Feature<SelectionGeometry> | null) {
  const layer = useMemo(
    () =>
      new GeoJsonLayer<Feature<SelectionGeometry>>({
        id: "utilities-buffer",
        data,
        filled: false,
        getLineColor: WHITE,
        stroked: true,
        getLineWidth: 3,
        lineWidthUnits: "pixels",
        extensions: [new PathStyleExtension({ dash: true, highPrecisionDash: true })],
        // this prop doesn't exist in both official typings
        // and the ones we use
        getDashArray: [3, 3],
      } as GeoJsonLayerProps<Feature<SelectionGeometry>>),
    [data]
  );
  return layer;
}
